// src/layouts/person/index.js
/* eslint-disable */

import React, { useState, useEffect, useCallback } from "react";

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import AppFormDialog from "components/common/AppFormDialog";
import Button from "@mui/material/Button";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ClientListTable from "layouts/person/ClientListTable";

import personTableData from "layouts/person/data/personTableData";
import personService from "services/personService";

import UpdatePersonForm from "../../forms/person/updatePersonForm";
import { useNavigate, useLocation } from "react-router-dom";

function Person() {
  const navigate = useNavigate();
  const [persons, setPersons] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [personToEdit, setPersonToEdit] = useState(null);

const location = useLocation();

const load = useCallback(async () => {
  setIsLoading(true);
  try {
    const personsData = await personService.getActiveClients();
    setPersons(personsData || []);
  } catch (error) {
    console.error("Error fetching persons:", error);
    setPersons([]);
  } finally {
    setIsLoading(false);
  }
}, []);

useEffect(() => {
  load();
}, [load, location.key]);

useEffect(() => {
  const onFocus = () => load();

  const onVisibility = () => {
    if (document.visibilityState === "visible") load();
  };

  window.addEventListener("focus", onFocus);
  document.addEventListener("visibilitychange", onVisibility);

  return () => {
    window.removeEventListener("focus", onFocus);
    document.removeEventListener("visibilitychange", onVisibility);
  };
}, [load]);

const refreshPersons = load;


  // Editar
  const handleOpenEditModal = (personId) => {
    const person = persons.find((p) => p.Id === personId);
    setPersonToEdit(person);
    setIsEditModalOpen(true);
  };

  const handleCloseEditModal = async () => {
    setIsEditModalOpen(false);
    setPersonToEdit(null);
    await refreshPersons();
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={3} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="space-between"
              >
                <MDTypography variant="h6" color="white">
                  Clientes
                </MDTypography>
                <MDBox display="flex" gap={1}>
                  <Button
                    color="inherit"
                    onClick={() => navigate("/client/inactive")}
                  >
                    Ver inactivos
                  </Button>
                </MDBox>
              </MDBox>
              <MDBox pt={3}>
                <ClientListTable
                  persons={persons}
                  isLoading={isLoading}
                  makeTable={personTableData}
                  onEdit={handleOpenEditModal}
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />

      {/* Modal editar */}
      {personToEdit && (
        <AppFormDialog
          open={isEditModalOpen}
          onClose={handleCloseEditModal}
          title={personToEdit?.Name ? `Editar cliente: ${personToEdit.Name}` : "Editar cliente"}
        >
            <UpdatePersonForm
              closeForm={handleCloseEditModal}
              person={personToEdit}
              onUpdateSuccess={async (updatedId) => {
                const id = updatedId ?? personToEdit?.Id;

                try {
                  if (!id) return;

                  // 1) Traer la persona actualizada (DTO simple)
                  const updated = await personService.getPersonById(id);
                  if (!updated) return;

                  // 2) Si dejó de ser Cliente (o quedó inactiva), la sacamos al toque del listado
                  if (updated.Type !== "Cliente" || updated.IsActive === false) {
                    setPersons((prev) => prev.filter((p) => p.Id !== id));
                    return;
                  }

                  // 3) Si sigue siendo Cliente activo, reemplazamos inmediato en state
                  setPersons((prev) => {
                    const idx = prev.findIndex((p) => p.Id === id);
                    if (idx >= 0) {
                      const next = [...prev];
                      next[idx] = { ...next[idx], ...updated };
                      return next;
                    }
                    // por si no estaba, lo agregamos arriba
                    return [updated, ...prev];
                  });
                } finally {
                  // 4) “por seguridad”: refetch completo
                  await refreshPersons();
                }
              }}
            />

        </AppFormDialog>
      )}
    </DashboardLayout>
  );
}

export default Person;
